import { useState, useRef, useCallback } from 'react'
import RatingIcon, { iconLabel } from './RatingIcon'

export default function IconHistoryTooltip({ iconsData, currentIcon }) {
  const [show, setShow] = useState(false)
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 })
  const triggerRef = useRef(null)

  // Parse icons_data if it's a string
  const icons = typeof iconsData === 'string' ? JSON.parse(iconsData) : (iconsData || [])

  const history = icons.filter(i => i.posicion > 1).sort((a, b) => a.posicion - b.posicion)

  const handleMouseEnter = useCallback(() => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect()
      setTooltipPos({
        top: rect.top - 8,
        left: rect.left + rect.width / 2
      })
    }
    setShow(true)
  }, [])

  // Display icon: use currentIcon string id if present, else bulb_off as default
  const displayIconId = currentIcon || 'bulb_off'

  return (
    <div
      ref={triggerRef}
      className="relative inline-flex items-center justify-center"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShow(false)}
    >
      <RatingIcon iconId={displayIconId} size="table" />


      {show && icons.length > 1 && (
        <div
          className="fixed z-[9999] min-w-[180px]"
          style={{
            top: tooltipPos.top + 'px',
            left: tooltipPos.left + 'px',
            transform: 'translate(-50%, -100%)'
          }}
        >
          <div className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-600 rounded-lg shadow-lg p-2">
            <div className="text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase mb-1">Historial</div>
            {icons.map((icon, i) => (
              <div key={i} className="flex items-center gap-2 py-0.5">
                <RatingIcon iconId={icon.nombre || icon.icon_id || icon.id} size="sm" />
                <span className="text-[10px] text-gray-600 dark:text-gray-300 flex-1">{iconLabel(icon.nombre || icon.icon_id || icon.id)}</span>
                {i === 0 && <span className="text-[8px] bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-300 px-1 rounded">actual</span>}
                <span className="text-[9px] text-gray-400">
                  {icon.fecha_asignado ? new Date(icon.fecha_asignado).toLocaleDateString('es-CL', { day: '2-digit', month: 'short' }) : ''}
                </span>
              </div>
            ))}
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-2 h-2 bg-white dark:bg-slate-800 border-r border-b border-gray-200 dark:border-slate-600 transform rotate-45 translate-y-1" />
          </div>
        </div>
      )}
    </div>
  )
}
